module.exports = __webpack_public_path__ + "img/woman-dark-small.16495878.svg";